import { ConnectToBizsolMutation } from "@/generated/graphql";
import { BackendErrorExtraInfoKeys, ErrorCode } from "@/libs/errors";
import { graphql, HttpResponse } from "msw";

export const connectToBizsolHandler = graphql.mutation<ConnectToBizsolMutation>(
  "connectToBizsol",
  ({ query, variables }) => {
    return HttpResponse.json({
      data: {
        connectToBizsol: {},
      },
      errors: [
        {
          extensions: {
            code: ErrorCode[
              ErrorCode.BIZSOL_USER_IS_ALREADY_CONNECTED_TO_ANOTHER_MIKATANO_ID
            ],
            [BackendErrorExtraInfoKeys.BIZSOL_SUB]: "current_sso_bizsol_sub",
          },
        },
        // {
        //   extensions: {
        //     code: ErrorCode.BIZSOL_USER_IS_ALREADY_CONNECTED,
        //   },
        // },
        {
          extensions: {
            code:
              ErrorCode[ErrorCode.BIZSOL_REQUEST_FAILED] +
              ": service time is over. [210]",
          },
        },
      ],
    });
  }
);
